module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921041149_T.567b89bd.jpg";